export function fireTradeLoading(message = "Submitting trade…") {
    window.dispatchEvent(new CustomEvent("savvy-trade-loading", { detail: { message } }));
}

export function fireTradeToast(message, type = "info") {
    window.dispatchEvent(
        new CustomEvent("savvy-trade-toast", { detail: { message, type } })
    );
}
